module.exports = __webpack_public_path__ + "img/position_GK.1a854f84.png";